"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderWrapper = void 0;
var react_1 = __importStar(require("react"));
var ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
var Loader_1 = __importDefault(require("./Loader"));
var LoaderWrapper = function (props) {
    var className = props.className, contentType = props.contentType, defaultHeight = props.defaultHeight, disableWaitPeriod = props.disableWaitPeriod, loadingStatus = props.loadingStatus, reduxErrorStatus = props.reduxErrorStatus, reloadFunction = props.reloadFunction, streamItem = props.streamItem, _a = props.waitPeriod, waitPeriod = _a === void 0 ? 60000 : _a;
    var _b = (0, react_1.useState)(false), loadingFailed = _b[0], setLoadingFailed = _b[1];
    var timer = (0, react_1.useRef)();
    var mounted = (0, react_1.useRef)(false);
    var checkIfLoadingFailed = (0, react_1.useCallback)(function () {
        if (loadingStatus) {
            // need to be explicit about which setTimeout we're using for typescript
            var timerId = window.setTimeout(function () {
                if (!disableWaitPeriod && loadingStatus && mounted.current) {
                    setLoadingFailed(true);
                }
            }, waitPeriod);
            if (mounted.current) {
                timer.current = timerId;
            }
        }
    }, [disableWaitPeriod, loadingStatus, waitPeriod]);
    var tryReload = (0, react_1.useCallback)(function () {
        reloadFunction();
        setLoadingFailed(false);
        checkIfLoadingFailed();
    }, [reloadFunction, checkIfLoadingFailed]);
    (0, react_1.useEffect)(function () {
        mounted.current = true;
        checkIfLoadingFailed();
        (function () {
            mounted.current = false;
            if (timer.current) {
                clearTimeout(timer.current);
            }
        });
    }, [checkIfLoadingFailed]);
    var error = react_1.default.createElement(ErrorMessage_1.default, { error: reduxErrorStatus, reload: tryReload, content: contentType });
    return (react_1.default.createElement("div", { className: className }, loadingStatus ? loadingFailed ? error : react_1.default.createElement(Loader_1.default, { defaultHeight: defaultHeight, streamItem: streamItem }) : error));
};
exports.LoaderWrapper = LoaderWrapper;
exports.default = exports.LoaderWrapper;
